<template>
  <v-app>
    <nav-bar
      v-if="!$router.currentRoute.meta.fullPage"
      style="z-index: 6;"
    />
    <v-main>
      <v-container v-if="!$router.currentRoute.meta.fullPage">
        <router-view />
        <SnackBar />
      </v-container>
      <router-view v-else />
    </v-main>
    <v-footer
      v-if="isDebugMode"
      app
      fixed
    >
      Debug Mode Breakpoint: {{ $vuetify.breakpoint.name }}
    </v-footer>
  </v-app>
</template>

<script>
import SnackBar from './components/SnackBar'
import NavBar from './components/NavBar'
export default {
  name: 'APP',
  components: { NavBar, SnackBar },
  computed: {
    isDebugMode () {
      return window.laravel.app_mode === 'local'
    }
  },
}
</script>

<style scoped>

</style>
